module.exports = __webpack_public_path__ + "img/9788954612906.607e31c0.jpg";